// extracted by mini-css-extract-plugin
export default {"main":"_9badbb58bf","tit":"_53fe10ff7f","maintitle":"bf5bb25d15","ylw":"f462916712","white":"_9a9f01fc0c","mv_title":"_6d9d69fc77","mv_nc":"b446a92799","mv_in":"_712530d0da"};